import { motion } from "framer-motion";
import React, { useState } from "react";

const TOGGLE_CLASSES =
  "text-sm font-medium flex items-center col-span-1 px-3 md:py-1.5 transition-colors relative z-10";

const SliderToggle = ({ choices, selected, setSelected }) => {
  return (
    <div className="relative grid grid-cols-2 gap-x-2 items-center">
      <button
        className={`${TOGGLE_CLASSES} ${
          selected === choices[0] ? "text-white" : "text-slate-800"
        }`}
        onClick={() => {
          setSelected(choices[0]);
        }}
      >
        <span className="relative z-10">{choices[0]}</span>
      </button>
      <button
        className={`${TOGGLE_CLASSES} ${
          selected === choices[1] ? "text-white" : "text-slate-800"
        }`}
        onClick={() => {
          setSelected(choices[1]);
        }}
      >
        <span className="relative z-10">{choices[1]}</span>
      </button>
      <div
        className={`absolute inset-0 z-0 flex ${
          selected === choices[1] ? "justify-end" : "justify-start"
        }`}
      >
        <motion.span
          layout
          transition={{ type: "spring", damping: 15, stiffness: 250 }}
          className="w-1/2 rounded-md bg-gradient-to-r from-ssblue to-sspurple"
        />
      </div>
    </div>
  );
};

export default SliderToggle;
